'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _TermsAndConditionsWithToggle = require('acq-components/lib/composite-components/TermsAndConditionsWithToggle/TermsAndConditionsWithToggle');

var _JapanTermsAndConditionsList = require('acq-components/lib/composite-components/TermsAndConditionsWithToggle/variants/JapanTermsAndConditionsList');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _termsAndConditions = require('../../redux/selectors/termsAndConditions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsAndConditionsWrapperWithToggle = function TermsAndConditionsWrapperWithToggle(_ref) {
  var styles = _ref.styles,
      header = _ref.header,
      content = _ref.content,
      shadeAlternator = _ref.shadeAlternator;
  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded()
    },
    _react2.default.createElement(_TermsAndConditionsWithToggle.TermsAndConditionsWithToggle, {
      ContentComponent: _JapanTermsAndConditionsList.JapanTermsAndConditionsList,
      header: header,
      content: content,
      styles: styles.termsAndConditionsWithToggle,
      isOpen: true
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    header: (0, _termsAndConditions.getHeader)(state),
    content: (0, _termsAndConditions.getContent)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TermsAndConditionsWrapperWithToggle);